/* Nieuw menu (2026): gedrag van de panelen op desktop, plus twee aanvullingen
   op het mobiele menu (beelden laden bij openen, focus bij de schermen).

   Desktop, volgens de afspraken op het menubord:
   - Aanwijzen opent een paneel na 120 ms, zodat het niet openschiet als je er
     alleen langs beweegt.
   - Staat er al een paneel open, dan wisselt het direct naar het volgende,
     zonder animatie. Beweeg je schuin omlaag naar het paneel en kom je
     onderweg over een ander item, dan wacht het wisselen heel even.
   - Verlaten heeft 250 ms speling.
   - Klikken op het pijltje, Enter en spatie werken ook; Esc sluit en zet de
     focus terug op het pijltje. Op een tablet opent de eerste tik op een item
     het paneel, de tweede gaat naar de pagina.

   De markup komt uit snippets/cn-menu-desktop.liquid en cn-menu-paneel.liquid:
   elk item met een paneel is een <li data-cn-item="id van het paneel">. */
(() => {
  const header = document.getElementById('headerSection');
  if (!header || !header.querySelector('.cn-nav')) return;

  const OPEN_MS = 120;
  const SLUIT_MS = 250;
  const UIT_MS = 120;
  const MIKKEN_MS = 90;

  const items = Array.from(header.querySelectorAll('[data-cn-item]'));
  const scrim = document.querySelector('[data-cn-scrim]');
  const kaart = header.querySelector('.header-custom-empty');

  let open = null;
  let openTimer = 0;
  let sluitTimer = 0;
  let laatstePointer = 'mouse';
  let beweging = { dx: 0, dy: 0 };
  let vorige = null;

  const paneelVan = (li) => document.getElementById(li.dataset.cnItem);
  const knopVan = (li) => li.querySelector(':scope > .cn-nav__toggle');
  const isMega = (li) => li.hasAttribute('data-cn-mega');

  /* Wit vlak onder het actieve item in de categoriebalk (zie cn-menu.css). Het
     volgt het open paneel; staat er niets open, dan rust het op de pagina waar
     je bent, of het verdwijnt. */
  const balk = header.querySelector('.header__row--nav');
  const nav = header.querySelector('.cn-nav');
  const huidig = nav.querySelector(':scope > .cn-nav__item.is-current');
  const pil = document.createElement('span');
  pil.className = 'cn-nav__pil';
  pil.setAttribute('aria-hidden', 'true');
  balk?.prepend(pil);
  let pilWeg = 0;
  let pilFrame = 0;

  function zetPil(stil = false) {
    const li = open && nav.contains(open) ? open : huidig;
    if (!balk || !li || header.classList.contains('nav-collapsed')) {
      if (pil.classList.contains('is-zichtbaar')) pilWeg = performance.now();
      pil.classList.remove('is-zichtbaar');
      return;
    }
    // Is het net weggevaagd, dan schuift het terug in plaats van te springen.
    const zichtbaar = pil.classList.contains('is-zichtbaar') || performance.now() - pilWeg < UIT_MS;
    const r = li.getBoundingClientRect();
    pil.classList.toggle('is-stil', stil || !zichtbaar);
    pil.style.width = r.width + 'px';
    pil.style.transform = 'translate(' + (r.left - balk.getBoundingClientRect().left) + 'px, -50%)';
    if (pil.classList.contains('is-stil')) {
      // Eerst de plek laten tekenen, dan pas de overgangen terug aanzetten.
      pil.getBoundingClientRect();
      pil.classList.remove('is-stil');
    }
    pil.classList.add('is-zichtbaar');
  }

  // Bij wisselen gaan sluiten en openen samen: het vlak maar één keer zetten.
  const pilVolgt = () => {
    cancelAnimationFrame(pilFrame);
    pilFrame = requestAnimationFrame(() => zetPil());
  };

  function toonScrim(aan) {
    if (!scrim) return;
    clearTimeout(scrim.cnTimer);
    if (aan) {
      scrim.hidden = false;
      scrim.getBoundingClientRect();
      scrim.classList.add('is-open');
    } else {
      scrim.classList.remove('is-open');
      scrim.cnTimer = setTimeout(() => {
        if (!scrim.classList.contains('is-open')) scrim.hidden = true;
      }, UIT_MS);
    }
  }

  function sluiten(li, direct = false, wissel = false) {
    const paneel = paneelVan(li);
    li.classList.remove('is-open');
    knopVan(li)?.setAttribute('aria-expanded', 'false');
    if (open === li) open = null;
    if (paneel) {
      clearTimeout(paneel.cnTimer);
      paneel.classList.toggle('is-direct', direct);
      paneel.classList.remove('is-open');
      if (direct) {
        paneel.hidden = true;
      } else {
        paneel.cnTimer = setTimeout(() => {
          if (!paneel.classList.contains('is-open')) paneel.hidden = true;
        }, UIT_MS);
      }
    }
    if (!wissel && isMega(li)) toonScrim(false);
    pilVolgt();
  }

  function openen(li, direct = false) {
    clearTimeout(openTimer);
    clearTimeout(sluitTimer);
    if (open === li) return;
    const paneel = paneelVan(li);
    if (!paneel) return;

    const was = open;
    if (was) sluiten(was, true, isMega(was) && isMega(li));

    clearTimeout(paneel.cnTimer);
    const zonderAnimatie = direct || !!was;
    paneel.classList.toggle('is-direct', zonderAnimatie);
    paneel.hidden = false;
    // Eerst de begintoestand laten tekenen, anders slaat de browser de overgang over.
    if (!zonderAnimatie) paneel.getBoundingClientRect();
    paneel.classList.add('is-open');

    li.classList.add('is-open');
    knopVan(li)?.setAttribute('aria-expanded', 'true');
    open = li;
    if (isMega(li)) toonScrim(true);
    pilVolgt();
    opwarmen(li);
    buren(li).forEach(opwarmen);
  }

  // De beelden in een paneel laden pas als het opengaat (het staat op hidden,
  // dus loading=lazy wacht). Wie een item aanwijst, opent het waarschijnlijk:
  // dan halen we de beelden van dat paneel alvast op, en bij openen ook die van
  // de buren in de balk. Zo staan ze er meestal al als het paneel verschijnt.
  const opwarmen = (li) => {
    const paneel = li && paneelVan(li);
    if (!paneel || paneel.cnWarm) return;
    paneel.cnWarm = true;
    paneel.querySelectorAll('img[loading="lazy"]').forEach((img) => {
      img.loading = 'eager';
    });
  };
  const buren = (li) => {
    const lijst = Array.from(li.parentElement.querySelectorAll(':scope > [data-cn-item]'));
    const i = lijst.indexOf(li);
    return [lijst[i - 1], lijst[i + 1]];
  };

  const sluitLater = () => {
    clearTimeout(sluitTimer);
    sluitTimer = setTimeout(() => open && sluiten(open), SLUIT_MS);
  };

  // Richting van de muis, voor het schuin omlaag bewegen naar een paneel.
  header.addEventListener(
    'pointermove',
    (e) => {
      if (vorige) beweging = { dx: e.clientX - vorige.x, dy: e.clientY - vorige.y };
      vorige = { x: e.clientX, y: e.clientY };
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerdown',
    (e) => {
      laatstePointer = e.pointerType || 'mouse';
      if (open && !open.contains(e.target)) sluiten(open);
    },
    { capture: true, passive: true }
  );

  items.forEach((li) => {
    li.addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'touch') return;
      opwarmen(li);
      clearTimeout(sluitTimer);
      clearTimeout(openTimer);
      if (open === li) return;
      if (open) {
        // Wisselen gaat direct, behalve als de muis duidelijk omlaag beweegt:
        // dan is iemand waarschijnlijk op weg naar het paneel dat al open staat.
        const omlaag = beweging.dy > 0 && beweging.dy >= Math.abs(beweging.dx) * 0.6;
        if (omlaag) openTimer = setTimeout(() => openen(li, true), MIKKEN_MS);
        else openen(li, true);
        return;
      }
      openTimer = setTimeout(() => openen(li), OPEN_MS);
    });

    li.addEventListener('pointerleave', (e) => {
      if (e.pointerType === 'touch') return;
      clearTimeout(openTimer);
      if (open === li) sluitLater();
    });

    knopVan(li)?.addEventListener('click', () => {
      if (open === li) sluiten(li);
      else openen(li);
    });
    knopVan(li)?.addEventListener('focus', () => opwarmen(li));

    // Tablet: eerste tik opent het paneel, de tweede volgt de link.
    li.querySelector(':scope > a')?.addEventListener('click', (e) => {
      if (laatstePointer !== 'touch' || open === li) return;
      e.preventDefault();
      openen(li);
    });

    li.addEventListener('focusout', (e) => {
      if (open !== li) return;
      if (e.relatedTarget && li.contains(e.relatedTarget)) return;
      // Klik op een lege plek in het paneel: focus valt weg, maar je bent er nog.
      if (!e.relatedTarget && li.matches(':hover')) return;
      sluiten(li);
    });
  });

  // Over een item zonder paneel (Sale): een open paneel sluit meteen.
  header.querySelectorAll('.cn-nav__item:not([data-cn-item])').forEach((li) => {
    li.addEventListener('pointerenter', (e) => {
      if (e.pointerType === 'touch' || !open) return;
      clearTimeout(openTimer);
      clearTimeout(sluitTimer);
      sluiten(open);
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape' || !open) return;
    const li = open;
    const focusErin = li.contains(document.activeElement);
    sluiten(li, true);
    if (focusErin) knopVan(li)?.focus();
  });

  // Header schuift weg bij scrollen of klapt in naar het mobiele menu: paneel dicht.
  window.addEventListener(
    'scroll',
    () => {
      if (open && kaart && kaart.classList.contains('header-hidden')) sluiten(open, true);
    },
    { passive: true }
  );
  window.addEventListener('resize', () => {
    if (open && header.classList.contains('nav-collapsed')) sluiten(open, true);
  });

  // Het witte vlak meteen op zijn plek, en opnieuw als de balk van breedte
  // verandert, de balk inklapt of het lettertype binnen is.
  const pilStil = () => {
    cancelAnimationFrame(pilFrame);
    pilFrame = requestAnimationFrame(() => zetPil(true));
  };
  if (window.ResizeObserver) new ResizeObserver(pilStil).observe(nav);
  else pilStil();
  document.fonts?.ready.then(pilStil);
  ['openSheet', 'headerSearchInput'].forEach((id) => {
    document.getElementById(id)?.addEventListener('pointerdown', () => open && sluiten(open, true));
  });

  /* Bovenste rij: past hij niet (laptops, Duits eerder), dan gaan de losse
     servicelinks een voor een naar "Meer", te beginnen bij data-cn-prio 1. Zo
     blijven zoekveld, account en winkelwagen altijd in beeld. */
  const rij = header.querySelector('.header__row--top');
  const rechts = header.querySelector('.header__row-right');
  const meer = header.querySelector('[data-cn-meer]');
  const losse = Array.from(header.querySelectorAll('.cn-boven > [data-cn-prio]')).sort((a, b) => a.dataset.cnPrio - b.dataset.cnPrio);
  const kopieVan = (li) => meer && meer.querySelector('[data-cn-prio="' + li.dataset.cnPrio + '"]');
  const pastBoven = () => rechts.getBoundingClientRect().right <= rij.getBoundingClientRect().right + 1;
  const pasBovenAan = () => {
    if (!rij || !rechts || !meer || !losse.length) return;
    if (meer.contains(document.activeElement) || open === meer) return;
    losse.forEach((li) => {
      li.hidden = false;
      const kopie = kopieVan(li);
      if (kopie) kopie.hidden = true;
    });
    meer.hidden = true;
    // Ingeklapt (mobiele header) staat de hele rij met links uit: niets te doen.
    if (header.classList.contains('nav-collapsed') || !rij.offsetWidth || pastBoven()) return;
    meer.hidden = false;
    for (const li of losse) {
      if (pastBoven()) break;
      li.hidden = true;
      const kopie = kopieVan(li);
      if (kopie) kopie.hidden = false;
    }
  };
  let bovenFrame = 0;
  const pasBovenAanStraks = () => {
    cancelAnimationFrame(bovenFrame);
    bovenFrame = requestAnimationFrame(pasBovenAan);
  };
  pasBovenAan();
  window.addEventListener('resize', pasBovenAanStraks);
  window.addEventListener('load', pasBovenAan);
  document.fonts?.ready.then(pasBovenAan);

  // Downloadknoppen onder het app-kaartje (desktop en mobiel): meten zoals de
  // sectie "Download de app", met plek 'menu' erbij.
  document.addEventListener('click', (e) => {
    const knop = e.target.closest && e.target.closest('.cn-store[data-cn-app]');
    if (knop && typeof window.gtag === 'function') {
      window.gtag('event', 'cn_app_download', { send_to: window.cnGa4Id, store: knop.dataset.cnApp, page_path: location.pathname, plek: 'menu' });
    }
  });

  /* ---------- Mobiel menu ---------- */
  const sheet = document.getElementById('sheet');
  if (!sheet) return;

  // Beelden staan op data-cn-src (zie cn-menu-mobiel.liquid) en laden pas als
  // iemand het menu opent. pointerdown is net iets eerder dan click.
  let beeldenGeladen = false;
  const laadBeelden = () => {
    if (beeldenGeladen) return;
    beeldenGeladen = true;
    sheet.querySelectorAll('img[data-cn-src]').forEach((img) => {
      if (img.dataset.cnSrcset) img.srcset = img.dataset.cnSrcset;
      img.src = img.dataset.cnSrc;
      img.removeAttribute('data-cn-src');
      img.removeAttribute('data-cn-srcset');
    });
  };
  const openKnop = document.getElementById('openSheet');
  openKnop?.addEventListener('pointerdown', laadBeelden, { passive: true });
  openKnop?.addEventListener('click', laadBeelden);

  // Schermen buiten beeld zijn niet bereikbaar met Tab of een schermlezer.
  const schermen = Array.from(sheet.querySelectorAll('.cn-mm-sub'));
  schermen.forEach((s) => (s.inert = true));
  const alleDicht = () => {
    schermen.forEach((s) => (s.inert = true));
    sheet.querySelectorAll('.cn-mm__rij[aria-expanded="true"]').forEach((r) => r.setAttribute('aria-expanded', 'false'));
  };

  // Productfoto's en banner van een categoriescherm staan op data-cn-sub-src:
  // die laden pas bij het openen van dat scherm, niet bij het openen van het menu.
  const laadScherm = (scherm) => {
    scherm.querySelectorAll('img[data-cn-sub-src]').forEach((img) => {
      if (img.dataset.cnSubSrcset) img.srcset = img.dataset.cnSubSrcset;
      img.src = img.dataset.cnSubSrc;
      img.removeAttribute('data-cn-sub-src');
      img.removeAttribute('data-cn-sub-srcset');
    });
  };

  sheet.querySelectorAll('.cn-mm__rij[data-submenu]').forEach((rij) => {
    const doel = document.getElementById('submenu-' + rij.dataset.submenu);
    if (doel) rij.addEventListener('pointerdown', () => laadScherm(doel), { passive: true });
    rij.addEventListener('click', () => {
      const scherm = document.getElementById('submenu-' + rij.dataset.submenu);
      if (!scherm) return;
      laadScherm(scherm);
      scherm.inert = false;
      rij.setAttribute('aria-expanded', 'true');
      scherm.scrollTop = 0;
      scherm.querySelector('[data-back]')?.focus({ preventScroll: true });
    });
  });

  schermen.forEach((scherm) => {
    scherm.querySelector('[data-back]')?.addEventListener('click', (e) => {
      const id = e.currentTarget.dataset.back;
      const rij = sheet.querySelector('.cn-mm__rij[data-submenu="' + id + '"]');
      rij?.setAttribute('aria-expanded', 'false');
      rij?.focus({ preventScroll: true });
      scherm.inert = true;
    });
  });

  ['closeBtn', 'scrim'].forEach((id) => document.getElementById(id)?.addEventListener('click', alleDicht));
  sheet.querySelectorAll('.close-all-btn').forEach((b) => b.addEventListener('click', alleDicht));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sheet.classList.contains('open')) alleDicht();
  });
})();
